/**
 * @generated SignedSource<<ac511d5518b2a23477d81338292afb0a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "useVoteButtonsLabel_votable",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "votesMode",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "currentViewerVote",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "singleVoteMode",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "VoteButton_votable"
    }
  ],
  "type": "Votable",
  "abstractKey": "__isVotable"
};

node.hash = "fe650834a6115a7aecbfb4897c06a33e";

module.exports = node;
